import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {  // 首页
    path: '/',
    name: 'home',
    component: HomeView
  },
  {  // 登录页
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {  // 注册页
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue')
  },
  {  // 解决方案
    path: '/TotalSolution',
    name: 'TotalSolution',
    component: () => import('../views/TotalSolution.vue')
  },
  {  // 项目案例
    path: '/ProjectCase',
    name: 'ProjectCase',
    component: () => import('../views/ProjectCase.vue')
  },
  {  // 生态合作
    path: '/EcologicalCooperation',
    name: 'EcologicalCooperation',
    component: () => import('../views/EcologicalCooperation.vue')
  },
  {  // 行业新闻
    path: '/TradeNews',
    name: 'TradeNews',
    component: () => import('../views/TradeNews.vue')
  },
  {  // 加入我们
    path: '/JoinWe',
    name: 'JoinWe',
    component: () => import('../views/JoinWe.vue')
  },
  {  // 关于我们
    path: '/AboutView',
    name: 'AboutView',
    component: () => import('../views/AboutView.vue')
  },
  {  // 补丁下载
    path: '/PatchDownload',
    name: 'PatchDownload',
    component: () => import('../views/PatchDownload.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
